import React from "react";
import JobManagerPage from "../JobManagerPage";

const AnalysisSection = () => {
  return (
    <div>
      <JobManagerPage />
    </div>
  );
};

export default AnalysisSection;
